export enum ToastrSeverities {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success'
}
